import { CollectionNames } from "../utils/types";
import {
  query,
  collection,
  where,
  getDocs,
  addDoc,
  writeBatch,
} from "firebase/firestore";
import { firestore } from "../config/firebaseConfig";
import { getUserId } from "../utils/functions";

export const getCollectionDocuments = async <T>(
  collectionName: CollectionNames
): Promise<T[] | null> => {
  const uid = getUserId();
  if (!uid) return null;
  try {
    const collectionRes = query(
      collection(firestore, collectionName),
      where("userId", "==", uid)
    );
    const res = await getDocs(collectionRes);
    const movies: any[] = [];
    res.docs.forEach((item) => {
      movies.push(item.data());
    });
    return movies.sort((a, b) => (b.timeStamp ?? 0) - (a.timeStamp ?? 0));
  } catch (e) {
    console.warn("Error in getCollectionDocuments", e);
    return null;
  }
};

export const addDocument = async <T>(
  payload: T,
  collectionName: CollectionNames
): Promise<boolean> => {
  try {
    await addDoc(collection(firestore, collectionName), payload);
    return true;
  } catch (e) {
    console.warn("Error in addDocument", e);
    return false;
  }
};

export const removeDocument = async (
  collectionName: CollectionNames,
  docId: number
): Promise<boolean> => {
  try {
    const uid = getUserId();
    if (!uid) return false;
    const q = query(
      collection(firestore, collectionName),
      where("movieId", "==", docId),
      where("userId", "==", uid)
    );
    const querySnapshot = await getDocs(q);
    const batch = writeBatch(firestore);
    querySnapshot.forEach((doc) => {
      batch.delete(doc.ref);
    });
    await batch.commit();

    return true;
  } catch (e) {
    console.warn("Error in removeDocument", e);
    return false;
  }
};

export const updateDocumentField = async <T extends { movieId: number }>(
  collectionName: CollectionNames,
  movieId: number,
  item: T
): Promise<boolean> => {
  try {
    const uid = getUserId();
    if (!uid) return false;
    const q = query(
      collection(firestore, collectionName),
      where("movieId", "==", movieId),
      where("userId", "==", uid)
    );
    const querySnapshot = await getDocs(q);
    const batch = writeBatch(firestore);
    querySnapshot.forEach((doc) => {
      batch.set(doc.ref, item);
    });
    await batch.commit();
    return true;
  } catch (e) {
    console.warn("Error in updateDocumentField", e);
    return false;
  }
};
